import React from "react";
import {
  FaTrashAlt,
  FaPhoneAlt,
  FaMoneyBillWaveAlt,
  FaChair,
  FaClock,
  FaEnvelope,
  FaStripeS,
  FaUndoAlt,
} from "react-icons/fa";
import { IoCloseSharp, IoCheckmarkSharp } from "react-icons/io5";
import FilledButton from "components/InterstellrComponents/FilledButton";
import moment from "moment-timezone";
import { FaHashtag, FaPencil } from "react-icons/fa6";

const BusinessCard = ({
  item,
  onDelete,
  onRestore,
  onChangeStatus,
  onEdit,
}) => {
  return (
    <>
      <div className="flex flex-col border relative border-slate-300 rounded-lg pb-12">
        {item?.company_logo ? (
          <img
            src={item?.company_logo}
            alt={item?.company_name}
            className="w-full h-40 object-contain rounded-t-lg"
          />
        ) : null}

        <div className="px-3 py-2">
          {item?.softDelete
            ? (() => {
                const deletionDate = moment(item.deletedOn);
                const expiryDate = deletionDate.clone().add(90, "days");
                const now = moment();
                const daysRemaining = Math.max(0, expiryDate.diff(now, "days"));

                return (
                  <div className="bg-red-700 rounded-full flex justify-center items-center py-1 mb-1">
                    <p className="text-white font-medium">
                      SOFT DELETED – {daysRemaining} days remaining
                    </p>
                  </div>
                );
              })()
            : null}

          {item?.status ? (
            <div className="bg-red-700 rounded-full flex justify-center items-center py-1 mb-1">
              <p className="text-white font-medium">Access Disabled</p>
            </div>
          ) : null}

          <h4 className="text-black font-medium text-base">
            {item?.company_name ??
              `${item?.manager_id?.firstname} ${item?.manager_id?.lastname}'s Team`}
          </h4>

          <p className="text-sm font-medium mt-4 underline mb-1">Managed by</p>

          <h4 className="text-black font-medium text-base">
            {item?.manager_id?.firstname} {item?.manager_id?.lastname}
          </h4>
          <div className="flex flex-row items-center justify-start">
            <FaPhoneAlt />
            <p className="text-black font-medium text-base ml-2">
              {item?.company_phone ?? item?.manager_id?.mobile ?? ""}
            </p>
          </div>
          <div className="flex flex-row items-center justify-start overflow-hidden">
            <FaEnvelope />
            <p className="text-black font-medium text-sm ml-2">
              {item?.manager_id?.email ?? ""}
            </p>
          </div>

          <p className="text-sm font-medium mt-4 underline mb-1">
            Plan Details
            {`${
              item?.companyPlan?.name
                ? ` - ${
                    item?.companyPlan?.name?.replace("Mind Pulse", "") ?? ""
                  }`
                : " - Heart"
            }`}
          </p>

          {item?.manager_id?.manager_code ? (
            <div className="flex flex-row items-center justify-start">
              <FaHashtag />
              <p className="font-medium text-base ml-2">
                {item?.manager_id?.manager_code ?? ""}
              </p>
            </div>
          ) : null}

          <div className="flex flex-row items-center justify-start">
            <FaChair color="#5153F5" />
            <p className="text-[#5153F5] font-medium text-base ml-2">
              {item?.seats ?? "0"} Seats | {item?.usedSeats ?? "0"} Used
            </p>
          </div>

          {item?.companyPlan ? (
            <>
              {item?.planFrequency ? (
                <>
                  <div className="flex flex-row items-center justify-start  text-[#ad8f2b]">
                    <FaClock />
                    <p className="font-medium text-base capitalize ml-2">
                      {item?.planFrequency} Payment
                    </p>
                  </div>

                  <div className="flex flex-row items-center justify-start  text-[#fc5203]">
                    <FaClock />
                    <p className="font-medium text-base capitalize ml-2">
                      Renews{" "}
                      {item?.companyPlanStartDate
                        ? moment(item?.companyPlanStartDate).format("MMM Do")
                        : ""}
                    </p>
                  </div>
                </>
              ) : null}

              <div className="flex flex-row items-center justify-start text-[#038000]">
                <FaMoneyBillWaveAlt />
                <p className="font-medium text-base ml-2">
                  $
                  {Number(
                    item?.perUserPrice ?? item?.companyPlan?.price ?? 0.0,
                  ).toFixed(2)}{" "}
                  AUD p/User
                </p>
              </div>

              {item?.companyPlan?.special_price ? (
                <div className="flex flex-row items-center justify-start text-[#038000]">
                  <p className="font-semibold text-sm capitalize">
                    Special Pricing Applied
                  </p>
                </div>
              ) : null}
            </>
          ) : null}
        </div>

        <div className="flex flex-row px-3 pb-3 absolute bottom-0 left-0 right-0">
          <div className="w-12">
            <FilledButton
              backgroundColor={item?.status ? "red" : "green"}
              borderRadius={96}
              onPress={() => onChangeStatus(item?._id)}
              icon={
                item?.status ? (
                  <IoCloseSharp className="text-white" />
                ) : (
                  <IoCheckmarkSharp className="text-white" />
                )
              }
            />
          </div>
          <div style={{ flex: 1 }} />

          <div className="w-12 ml-2">
            <FilledButton
              borderRadius={96}
              onPress={() => onEdit(item)}
              icon={<FaPencil className="text-white" />}
            />
          </div>

          <div style={{ flex: 1 }} />

          {item?.manager_id?.stripe_id ? (
            <>
              <div className="w-12 ml-2">
                <FilledButton
                  borderRadius={96}
                  onPress={() =>
                    (window.location.href = `https://dashboard.stripe.com/customers/${item?.manager_id?.stripe_id}`)
                  }
                  icon={<FaStripeS className="text-white" />}
                />
              </div>
              <div style={{ flex: 1 }} />
            </>
          ) : null}

          <div className="w-12">
            <FilledButton
              borderRadius={96}
              onPress={() =>
                !item?.softDelete ? onDelete(item?._id) : onRestore(item?._id)
              }
              backgroundColor={item?.softDelete ? "orange" : "#FF0000"}
              icon={
                item?.softDelete ? (
                  <FaUndoAlt className="text-white" />
                ) : (
                  <FaTrashAlt className="text-white" />
                )
              }
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default BusinessCard;
